// extracted by mini-css-extract-plugin
export default {"grabando":"MensajeGrabando_grabando__paXL-"};